import Marquee from "react-fast-marquee";
import { BRANDS } from "../../data/site";
import { useT } from "@/i18n/I18nContext";

export default function BrandMarquee() {
  const { t } = useT();
  return (
    <section
      id="marcas"
      data-testid="brands-section"
      className="relative py-24 md:py-32 border-y border-[var(--tt-border)]"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-12 mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <p className="tt-overline">{t("brands.overline")}</p>
          <h2 className="mt-4 font-serif text-3xl md:text-5xl leading-[1.05] text-[var(--tt-text)] max-w-2xl">
            {t("brands.heading_1")}{" "}
            <em className="italic text-[var(--tt-gold)]">{t("brands.heading_2")}</em>.
          </h2>
        </div>
        <p className="text-[var(--tt-text-muted)] max-w-md text-sm font-light">
          {t("brands.sub")}
        </p>
      </div>

      <div className="tt-marquee-mask">
        <Marquee gradient={false} speed={42} pauseOnHover className="overflow-hidden">
          {BRANDS.concat(BRANDS).map((b, i) => (
            <div
              key={`${b}-${i}`}
              data-testid={`brand-${b.toLowerCase().replace(/\s+/g, "-")}`}
              className="mx-10 md:mx-16 flex items-center"
            >
              <span className="font-serif text-3xl md:text-5xl tracking-tight text-[var(--tt-text-muted)] hover:text-[var(--tt-text)] transition-colors duration-500 italic font-light">
                {b}
              </span>
              <span className="ml-10 md:ml-16 w-1.5 h-1.5 rounded-full bg-[var(--tt-text-muted)] opacity-40" />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
